<script>
import { Bar } from 'vue-chartjs'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'

export default {
  extends: Bar,
  props: {
    buildings: Array
  },
  data() {
    return {
      labels: [],
      chartData: []
    }
  },
  beforeMount() {
    _.each(this.buildings, (building) => {
      this.labels.push(building.name)
      this.chartData.push(building.total_revenue)
    })
  },
  mounted () {
    this.renderChart(
      {
        labels: this.labels,
        datasets: [
          {
            label: 'Bhent Received',
            backgroundColor: '#f87979',
            data: this.chartData
          }
        ]
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        height: 300,
        tooltips: {
          enabled: false,
          custom: CustomTooltips,
          intersect: true,
          mode: 'index',
          position: 'nearest',
          callbacks: {
            labelColor: function (tooltipItem, chart) {
              return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor }
            }
          }
        }
      }
    )
  }
}
</script>
